<script>
import LayoutMain from "@/router/layouts/main";
import LayoutExperts from "@/router/layouts/experts";
import { api } from "@/state/services";
import ExpertsPlanCard from "@/components/widgets/experts-plan-card";

// Troca do plano da fatura pendente
export default {
  components: {
    LayoutMain,
    LayoutExperts,
    ExpertsPlanCard,
  },
  data() {
    return {
      loading: true,
      errored: false,

      plans: [],
      current: null,
      pending: null,
    };
  },
  computed: {
    // Sem plano do Experts ativo usa o layout sem menu; com plano ativo mantém o menu
    layout() {
      const user = this.$store.state.account.user;
      return user && user.expert == 'active' ? 'LayoutMain' : 'LayoutExperts';
    },
    // Planos disponíveis, exceto o da fatura atual
    options() {
      if (!this.pending) {
        return [];
      }
      return this.plans.filter(row => {
        if (row.id == this.pending.plan.id) {
          return false;
        }
        if (this.current && row.type <= this.current.type) {
          return false;
        }
        return true;
      });
    },
  },
  methods: {
    load() {
      this.loading = true;
      this.errored = false;

      Promise.all([api.get('experts'), api.get('experts/current')])
        .then(([plans, current]) => {
          if (plans.data.status == 'success') {
            this.plans = plans.data.list;
          }
          if (current.data.status == 'success') {
            this.current = current.data.plan;
            this.pending = current.data.pending;
          }

          // Sem fatura pendente para trocar
          if (!this.pending || this.pending.status != 'pending') {
            this.$router.replace('/experts');
          }
        })
        .catch(() => {
          this.errored = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    choose(plan) {
      this.$router.push('/experts/confirm/' + plan.id);
    },
  },
  mounted() {
    this.load();
  },
};
</script>

<template>
  <component :is="layout">
    <div class="experts">
      <router-link to="/experts" class="experts-back">
        <i class="bx bx-left-arrow-alt" aria-hidden="true"></i> Voltar
      </router-link>

      <div v-if="loading" class="text-center py-5">
        <b-spinner variant="default" role="status"></b-spinner>
      </div>
      <div v-else-if="errored" class="experts-box text-center">
        <p>Pedimos desculpas, não podemos recuperar as informações neste momento.</p>
        <button class="btn btn-default" v-on:click="load()">Tentar novamente</button>
      </div>
      <div v-else-if="pending">
        <div class="experts-intro">
          <h1 class="experts-title">Trocar o plano</h1>
          <p class="experts-subtitle">
            Sua fatura atual é do plano <strong>{{ pending.plan.name }}</strong> ({{ pending.total | currency }}).
            Escolha o novo plano: a fatura atual será cancelada e uma nova será gerada.
          </p>
        </div>

        <div v-if="options.length == 0" class="experts-box text-center">
          <p>Não há outro plano disponível para troca.</p>
          <router-link tag="a" to="/experts" class="btn btn-default">Voltar</router-link>
        </div>
        <div v-else>
          <h2 class="experts-pill">
            <span>ESCOLHA O NOVO</span>
            <strong>PLANO ANUAL</strong>
          </h2>
          <div class="experts-plans" :class="{ 'is-single': options.length == 1 }">
            <ExpertsPlanCard
              v-for="item in options"
              :key="item.id"
              :plan="item"
              :recommended="options.length > 1 && item.type == 3"
              :action="'Trocar para ' + item.name"
              @choose="choose"
            />
          </div>
        </div>
      </div>
    </div>
  </component>
</template>
